import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { ProgressSpinner } from 'primereact/progressspinner';

const GlobalLoader = () => {
    const loading = useSelector((state: RootState) => state.ui.loading);

    if (!loading) return null;

    return (
        <div className="global-loader-overlay">
            <ProgressSpinner />
        </div>
    );
};

export default GlobalLoader;
